import { ref } from 'vue';

/**
 * Quản lý state phân trang + loading dùng chung cho các tab lịch sử của khách hàng
 * (hóa đơn, bảo hành, thu cũ).
 *
 * @param {(page: number) => Promise<{items: any[], totalRow: number, totalPage: number}>} loader
 *   Hàm gọi API tương ứng, trả về dữ liệu đã chuẩn hóa.
 */
export default function useCustomerHistory(loader) {
  const items = ref([]);
  const totalItems = ref(0);
  const totalPages = ref(0);
  const currentPage = ref(1);
  const isLoading = ref(false);

  const fetchPage = async (page = 1) => {
    isLoading.value = true;
    currentPage.value = page;

    try {
      const { items: data, totalRow, totalPage } = await loader(page);
      items.value = data || [];
      totalItems.value = totalRow || 0;
      totalPages.value = totalPage || 0;
    } catch (error) {
      console.error('Lỗi tải lịch sử khách hàng:', error);
      items.value = [];
      totalItems.value = 0;
      totalPages.value = 0;
    } finally {
      isLoading.value = false;
    }
  };

  const onPageChange = (page) => {
    fetchPage(page);
  };

  return {
    items,
    totalItems,
    totalPages,
    currentPage,
    isLoading,
    fetchPage,
    onPageChange,
  };
}
